import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useTextOverflow } from "../../../../core/hooks/use-text-overflow";
import "./StatementCardList.scss";
import { RouteEnum } from "core/enum/route.enum";

const StatementCardList = ({ id, title, image, statementData }) => {
  const history = useHistory();
  const titleRef = useRef(null);

  useTextOverflow(titleRef, [title]);

  const handleClick = () => {
    // history.push({
    //   pathname: `/Statement/Statements/${id}`,
    //   state: { manifestData: statementData },
    // });
    history.push({
      pathname: RouteEnum.StatementDetail.replace(":id", String(id)),
      state: { manifestData: statementData },
    });
  };

  return (
    <Card className="statement-card-item" onClick={handleClick}>
      <div className="statement-flash-card-img">
        <img
          src={`${process.env.REACT_APP_PUBLIC_PATH}/${image}`}
          alt={title}
        />

        <div className="statement-dim-bg">
          <h2 ref={titleRef}>{title}</h2>
        </div>
      </div>
    </Card>
  );
};

export default StatementCardList;
